<template>

  <div>
    
      <div class="row mb-3">
        <div class="col-sm">
          <date-time v-model="value.date"></date-time>
          <ValidateMessage :error="validateErrors.date" />  
        </div>
        <div class="col-sm">
          <select-user v-model="value.assigned_user_id"></select-user>
          <ValidateMessage :error="validateErrors.assigned_user_id" />  
        </div>
      </div>
      
      <div class="mb-3">
        <textarea-autosize
          :placeholder="$t('Task')"
          v-model="value.comment"
          :min-height="30"
          :max-height="350"
          class="form-control">
          </textarea-autosize>
        <ValidateMessage :error="validateErrors.comment" />
      </div>

      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          class="btn btn-primary"
          @click="saveTask(value)">
          {{ $t('Save') }}
          </button>
        <button
          v-if="value._id"
          type="submit"
          class="btn btn-light"
          @click="$emit('cancel')">
          {{ $t('Cancel') }}
          </button>
      </div>
      
  </div>

</template>

<script>
import DateTime from '@/components/Fields/DateTime'
import SelectUser from '@/components/Fields/SelectUser'
import moment from 'moment'

export default {
  name: 'CandidateTaskForm',
  components: {
    DateTime,
    SelectUser
  },
  props: [
    'initValue'
  ],
  data () {
    return {
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue)
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        date: moment().add(1, 'day').set({hour: 8}).startOf('hour').toISOString(),
        assigned_user_id: this.$store.getters.getMe._id
      }, values)
    },
    /*
    saveTask
    */
    saveTask (data) {
      if (data._id) this.updateTask(data)
      else this.createTask(data)
    },
    /*
    resetTask
    */
    resetTask (data) {
      this.value.date = ''
      this.value.comment = ''
      this.validateErrors = false
    },
    /*
    createTask
    */
    createTask (data) {
      this.loading = true

      data.candidate_id = this.candidate._id
      data.job_id = this.selectedJob._id

      this.$store
      .dispatch('createTask', data)
      .then((result) => {
        this.loading = false
        this.$emit('created', result.data)
        this.resetTask()
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateTask
    */
    updateTask (data) {
      this.loading = true

      this.$store
      .dispatch('updateTask', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Task/CandidateTaskForm.vue